export default "__VITE_ASSET__zieNWvhQ__"